import React from 'react';
import { Link } from 'react-router';

const PaypalSubscription = () => {
  return (
    <div className='flex flex-col items-center justify-center min-h-screen p-4 text-center bg-primary'>
      <div className='max-w-2xl p-4 rounded-xl shadow-lg bg-secondary border border-tertiary'>
        <h1 className='text-3xl font-bold mb-6 text-white'>
          Thank You for Your Subscription!
        </h1>
        <div className='max-w-lg mx-auto'>
          <p className='text-xl mb-6 text-white'>
            🔥 You're Officially One of TheChamps!
          </p>
          <p className='text-lg mb-4 text-white'>
            Welcome to the next level of your fitness journey. You now have full
            access to exclusive challenges, unlimited AI meal tracking, and
            tools that help you build real, lasting momentum.
          </p>
          <p className='text-lg mb-8 text-white'>
            Let's turn your goals into achievements — one small win at a time.
            We're here with you every step of the way. 💪
          </p>
          <Link
            to='/'
            className='inline-block px-8 py-3 text-lg font-semibold rounded-lg bg-accent text-primary hover:bg-accentHover transition-colors duration-200'
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaypalSubscription;
